import { z } from 'zod'
import { type ConsumptionSheetERPSettings } from '../../models/ConsumptionSheetERPSettings'
import { ConsumptionSheetExpirationERPSettingsDTO, mapDTOToConsumptionSheetExpirationERPSettings, mapConsumptionSheetExpirationERPSettingsToDTO } from './ConsumptionSheetExpirationERPSettingsDTO'

export const ConsumptionSheetERPSettingsDTO = z.object({
  is_enabled: z.boolean(),
  expiration_settings: ConsumptionSheetExpirationERPSettingsDTO.nullish()
})

export type ConsumptionSheetERPSettingsDTO = z.infer<typeof ConsumptionSheetERPSettingsDTO>

export function mapConsumptionSheetERPSettingsToDTO (model: ConsumptionSheetERPSettings): ConsumptionSheetERPSettingsDTO {
  return {
    is_enabled: model.isEnabled,
    expiration_settings: model.expirationSettings?.periodUnit ? mapConsumptionSheetExpirationERPSettingsToDTO(model.expirationSettings) : undefined
  }
}

export function mapDTOToConsumptionSheetERPSettings (dto: ConsumptionSheetERPSettingsDTO): ConsumptionSheetERPSettings {
  return {
    isEnabled: dto.is_enabled,
    expirationSettings: dto.expiration_settings ? mapDTOToConsumptionSheetExpirationERPSettings(dto.expiration_settings) : undefined
  }
}
